var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 0H7.20005C5.87719 0 4.80005 1.07714 4.80005 2.4V21.6C4.80005 22.9238 5.87719 24 7.20005 24H16.8C18.1239 24 19.2 22.9238 19.2 21.6V2.4C19.2 1.07714 18.1239 0 16.8 0ZM18.24 21.6C18.24 22.3939 17.594 23.04 16.8 23.04H7.20005C6.40613 23.04 5.76005 22.3939 5.76005 21.6V2.4C5.76005 1.60608 6.40613 0.96 7.20005 0.96H16.8C17.594 0.96 18.24 1.60608 18.24 2.4V21.6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9601 1.91992H11.0401C10.7751 1.91992 10.5601 2.13498 10.5601 2.39992C10.5601 2.66486 10.7751 2.87992 11.0401 2.87992H12.9601C13.225 2.87992 13.4401 2.66486 13.4401 2.39992C13.4401 2.13498 13.225 1.91992 12.9601 1.91992Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.1201C11.7351 21.1201 11.52 21.3352 11.52 21.6001C11.52 21.8651 11.7351 22.0801 12 22.0801C12.265 22.0801 12.48 21.8651 12.48 21.6001C12.48 21.3352 12.265 21.1201 12 21.1201Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.72 3.83984H5.28005C5.01506 3.83984 4.80005 4.05491 4.80005 4.31984C4.80005 4.58483 5.01506 4.79984 5.28005 4.79984H18.72C18.985 4.79984 19.2 4.58478 19.2 4.31984C19.2 4.05491 18.985 3.83984 18.72 3.83984Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.72 19.2002H5.28005C5.01506 19.2002 4.80005 19.4153 4.80005 19.6802C4.80005 19.9451 5.01506 20.1602 5.28005 20.1602H18.72C18.985 20.1602 19.2 19.9451 19.2 19.6802C19.2 19.4153 18.985 19.2002 18.72 19.2002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.1d04c06a22d295b7b4374a2baf1185f5.svg";
export { ForwardRef as ReactComponent };